<template>
  <div >
    <sidebar-menu :menu="menu" showOneChild="true">
      <span slot="dropdown-icon"
        ><i class="fa fa-angle-down fa-lg" aria-hidden="true"></i>
      </span>
    </sidebar-menu>
    <!-- <b-sidebar > -->
    <!-- <ul v-for="menus in menu">
          <li>{{menus}}</li>
      </ul> -->
    <!-- <span v-for="menus in menu">{{menus}}</span> -->
    <!-- </b-sidebar> -->
  </div>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import Vue from "vue";
export default {
  name: "sidebaradvance",
  data: function() {
    return {
      name: "sidebaradvance",

      data: [],
      isHidden: true,
      menu: [],
    };
  },
  created: function() {
    this.sidebarMenu();
  },
  methods: {
    sidebarMenu() {
      var userdata = localStorage.getItem("userData");
      if (userdata) {
        var userInfo = JSON.parse(userdata);
        userInfo.body.map(item=>{
          if(item.title=='COD HUB Collection Closure'){
            item.class="text-wrap"
          }
        })
        this.menu = userInfo.body;
        console.log("menu", this.menu);
      } else {
        localStorage.clear();
        this.$router.push("login");
      }
    },
    // doSomething: function() {
    //    alert(" i m in doSomething");
    //  this.isHidden=false;
    // }
  },
};
</script>
<!-- <style type="text/css">
/* .v-sidebar-menu {
left: 0 !important;
position: absolute;
width: 100%;
top:0px !important;
} */
.v-sidebar-menu {
  background-color: #00c0ef !important;
  max-width: 210px !important;
  border-width: 0px !important;
  left: 0 !important;
  position: absolute;
  width: 100%;
  top:0px !important;
  
}
.v-sidebar-menu .vsm--dropdown .vsm--list {
  background-color: #00c0ef !important;
  border-width: 0px !important;
}
.v-sidebar-menu.vsm_expanded .vsm--item_open .vsm--link_level-1 {
  background-color: #f09642 !important;
  border-radius: 0px !important;
}
.v-sidebar-menu .vsm--link_level-1 .vsm--icon {
  background-color: #00c0ef !important;
  border-radius: 0px !important;
  size: 3px !important;
}
.v-sidebar-menu .vsm--link_hover,
.v-sidebar-menu .vsm--link:hover {
  background-color: #eceff1 !important ;
  border-radius: 0px !important;
}
.v-sidebar-menu .vsm--link_level-1.vsm--link_exact-active,
.v-sidebar-menu .vsm--link_level-1.vsm--link_active {
  background-color: #eceff1 !important ;
}
.sidebar-menu .vsm--link_level-1.vsm--link_active {
  background-color: #f09642 !important;
}
.v-sidebar-menu .vsm--toggle-btn {
  color: #00c0ef;
  background-color: #00c0ef !important;
  border-radius: 0px !important;
}
.v-sidebar-menu .vsm--link_level-1 .vsm--icon {
  height: 30px;
  line-height: 30px;
  width: 20px !important;
  text-align: center;
  border-radius: 0px !important;
}
.v-sidebar-menu .vsm--icon {
  display: inline-block;
  margin-right: 8px !important;
}
.v-sidebar-menu .vsm--link {
  font-size: 14px !important;
  font-weight: 400 !important;
}
.v-sidebar-menu .vsm--arrow {
  right: 1px !important;
}
.v-sidebar-menu .vsm--link_level-1.vsm--link_active,
v-sidebar-menu .vsm--link_level-1.vsm--link_exact-active {
  background-color: #f09642 !important;
}
.v-sidebar-menu .vsm--link_level-2.vsm--link_active,
v-sidebar-menu .vsm--link_level-1.vsm--link_exact-active {
  background-color: #f09642 !important;
}

.v-sidebar-menu.vsm_expanded .vsm--item_open .vsm--link_level-1 {
  color: #fff;
  background-color: #00c0ef !important;
}
.v-sidebar-menu .vsm--link_level-1.vsm--link_active,
.v-sidebar-menu .vsm--link_level-1.vsm--link_exact-active {
  -webkit-box-shadow: opx 0 0 0 #f09642 inset !important;
  box-shadow: inset 0px 0 0 0 #f09642 !important;
}
.vsm--link_hover {
  color: black !important;
}
.v-sidebar-menu .vsm--link_level-1 .vsm--icon {
  background-color: none !important;
  outline: none !important;
  outline-width: 0 !important;
  box-shadow: none;
  -moz-box-shadow: none !important;
  -webkit-box-shadow: none !important;
}

.v-sidebar-menu .vsm--link_level-1 .vsm--icon {
  background-color: none !important;
}
.vsm--link .vsm--link_level-1 .vsm--link_active {
  outline: none !important;
  outline-width: 0 !important;
  box-shadow: none;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
}
</style>-->

<style type="text/css">
/* .v-sidebar-menu {
left: 0 !important;
position: absolute;
width: 100%;
top:0px !important;
} */
.v-sidebar-menu {
  /* background-color: #00c0ef !important; */
  background-color: #3C4B64 !important;
  max-width: 100% !important;
  border-width: 0px !important;
  /* left: 0 !important; */
  position: absolute;
  width: 100%;
  top:0px !important;
  padding-left: 0px;
}
.v-sidebar-menu .vsm--dropdown .vsm--list {
  /* background-color: #00c0ef !important; */
  background-color: #3C4B64 !important;
  border-width: 0px !important;
}
.v-sidebar-menu.vsm_expanded .vsm--item_open .vsm--link_level-1 {
  background-color: #f09642 !important;
  border-radius: 0px !important;
}
.v-sidebar-menu .vsm--link_level-1 .vsm--icon {
  /* background-color: #00c0ef !important; */
  background-color: transparent !important;
  border-radius: 0px !important;
  size: 3px !important;
}
.v-sidebar-menu .vsm--link_hover,
.v-sidebar-menu .vsm--link:hover {
  background-color: #eceff1 !important ;
  border-radius: 0px !important;
}
.v-sidebar-menu .vsm--link_level-1.vsm--link_exact-active,
.v-sidebar-menu .vsm--link_level-1.vsm--link_active {
  background-color: #eceff1 !important ;
}
.sidebar-menu .vsm--link_level-1.vsm--link_active {
  background-color: #f09642 !important;
}
.v-sidebar-menu .vsm--toggle-btn {
  /* color: #00c0ef;
  background-color: #00c0ef !important; */
  color: #3C4B64;
  background-color: #3C4B64 !important;
  border-radius: 0px !important;
}
.v-sidebar-menu .vsm--link_level-1 .vsm--icon {
  height: 30px;
  line-height: 30px;
  width: 20px !important;
  text-align: center;
  border-radius: 0px !important;
}
.v-sidebar-menu .vsm--icon {
  display: inline-block;
  margin-right: 8px !important;
}
.v-sidebar-menu .vsm--link {
  font-size: 12px !important;
  font-weight: 400 !important;
  padding: 3px !important;
}
.v-sidebar-menu .vsm--arrow {
  right: 1px !important;
}

.v-sidebar-menu .vsm--arrow_open {
  transform: rotate(180deg) 
}

.v-sidebar-menu .vsm--link_level-1.vsm--link_active,
v-sidebar-menu .vsm--link_level-1.vsm--link_exact-active {
  background-color: #f09642 !important;
}
.v-sidebar-menu .vsm--link_level-2.vsm--link_active,
v-sidebar-menu .vsm--link_level-1.vsm--link_exact-active {
  background-color: #f09642 !important;
}

.v-sidebar-menu.vsm_expanded .vsm--item_open .vsm--link_level-1 {
  color: #fff;
  /* background-color: #00c0ef !important; */
  background-color: #3C4B64 !important;
}
.v-sidebar-menu .vsm--link_level-1.vsm--link_active,
.v-sidebar-menu .vsm--link_level-1.vsm--link_exact-active {
  -webkit-box-shadow: opx 0 0 0 #f09642 inset !important;
  box-shadow: inset 0px 0 0 0 #f09642 !important;
}
.vsm--link_hover {
  color: black !important;
}
.v-sidebar-menu .vsm--link_level-1 .vsm--icon {
  background-color: none !important;
  outline: none !important;
  outline-width: 0 !important;
  box-shadow: none;
  -moz-box-shadow: none !important;
  -webkit-box-shadow: none !important;
}

.v-sidebar-menu .vsm--link_level-1 .vsm--icon {
  background-color: none !important;
}
.vsm--link .vsm--link_level-1 .vsm--link_active {
  outline: none !important;
  outline-width: 0 !important;
  box-shadow: none;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
}

.vsm--dropdown .vsm--list .vsm--item{
  left: 10px;
}

.sidebar-lg-show .sidebar, .sidebar-show .sidebar {
    margin-left: 0 !important;
}

.sidebar {
    margin-left: -215px !important;
}

.vsm--link .vsm--link_level-2{
  border-left: 10px !important;
}

.vsm--dropdown{
  border-left: 2px solid #fff;
  margin-left: 15px;
}
</style>
